const name = "toast";
export default name;
